import { render, staticRenderFns } from "./insuranceDetail.vue?vue&type=template&id=462c60ed&scoped=true"
import script from "./insuranceDetail.vue?vue&type=script&lang=js"
export * from "./insuranceDetail.vue?vue&type=script&lang=js"
import style0 from "./insuranceDetail.vue?vue&type=style&index=0&id=462c60ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462c60ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462c60ed')) {
      api.createRecord('462c60ed', component.options)
    } else {
      api.reload('462c60ed', component.options)
    }
    module.hot.accept("./insuranceDetail.vue?vue&type=template&id=462c60ed&scoped=true", function () {
      api.rerender('462c60ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/insuranceDetail.vue"
export default component.exports